module.exports = __webpack_public_path__ + "static/media/envelope.c08f4307.svg";